import React from 'react';
import { MatchedDepositsTable } from './MatchedDepositsTable';
import { StyledFeeSection, StyledFeeSectionHeader } from '../../FeeSections.Styled';
import { Header3Text } from 'ui-toolkit';
import { IWireDepositData } from 'types/order/escrow/IWireDepositData';
import { ICheckDepositData } from 'types/order/escrow/ICheckDeposit';
import { IEscrowExpectedIncomingAchData } from 'types/accounting/data/IEscrowExpectedIncomingAchData';
interface IMatchedDepositsSectionProps {
  achDeposits: IEscrowExpectedIncomingAchData[];
  wireDeposits?: IWireDepositData[];
  checkDeposits?: ICheckDepositData[];
}

export const MatchedDepositsSection: React.FC<IMatchedDepositsSectionProps> = ({
  achDeposits,
  wireDeposits,
  checkDeposits,
}) => {
  return (
    <StyledFeeSection>
      <StyledFeeSectionHeader>
        <Header3Text>Matched to this file</Header3Text>
      </StyledFeeSectionHeader>
      <MatchedDepositsTable achDeposits={achDeposits} wireDeposits={wireDeposits} checkDeposits={checkDeposits} />
    </StyledFeeSection>
  );
};
